/**
 * Сохранение позиции прокрутки при перестройке раскладки (D-03, §3.5 п. 1, 5).
 *
 * При пересечении breakpoint'а дерево перестраивается: одноколоночный режим
 * заменяется двухпанельным и наоборот, компоненты размонтируются. Позиция
 * истории восстанавливается по `seq` последнего видимого сообщения
 * (CC §2.6 п. 5), позиция списка — по смещению прокрутки.
 *
 * Память живёт в модуле, а не в реплике: она описывает текущий сеанс работы
 * с окном, переживать перезагрузку ей незачем.
 */

const historyAnchors = new Map<string, number>()
const listOffsets = new Map<string, number>()

/** Запоминает `seq` последнего полностью видимого сообщения истории. */
export function rememberHistoryAnchor(conversationId: string, seq: number | null): void {
  if (seq === null) historyAnchors.delete(conversationId)
  else historyAnchors.set(conversationId, seq)
}

export function takeHistoryAnchor(conversationId: string): number | null {
  return historyAnchors.get(conversationId) ?? null
}

/** Смена пользователя: чужие позиции не восстанавливаются. */
export function clearScrollMemory(): void {
  historyAnchors.clear()
  listOffsets.clear()
}
